import React from "react";

/**
 * No-op layout for pages rendered inside a persistent shell layout.
 * BeforeEachRoute still wraps page content with a layout component;
 * when the shell already provides VerticalLayout/HorizontalLayout,
 * pages should use this instead of remounting the shell.
 */
const PassthroughLayout = ({ children }) => {
    return <>{children}</>;
};

export default PassthroughLayout;
